<template>
  <div id="app">
    <Header />
    <main id="main">
      <sectionKeyVisual />
      <sectionVision />
      <sectionMission />
      <sectionWorks />
      <sectionAbout />
      <sectionCompany />
    </main>
    <Footer />
  </div>
</template>

<script>
//components
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'
import sectionKeyVisual from '@/components/kv.vue'
import sectionVision from '@/components/vision.vue'
import sectionMission from '@/components/mission.vue'
import sectionWorks from '@/components/works.vue'
import sectionAbout from '@/components/about.vue'
import sectionCompany from '@/components/company.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    sectionKeyVisual,
    sectionVision,
    sectionMission,
    sectionWorks,
    sectionAbout,
    sectionCompany,
  },
  mounted(){
    setTimeout(() => {
      this.test();
    }, 600);
  },
  methods:{
    test: function() {
      document.getElementById('kv').classList.add('active')
    }
  }
}

</script>

<style lang="scss">

</style>
